import { initializeGrid } from "./base"
import { Config } from "../config"

if (document.querySelectorAll(".systems-index").length) {
  if (Config.showLcfsViews) {
    initializeGrid({
      gridName: "fses",
      autoSizeStrategy: {
        defaultMinWidth: 100,
        type: "fitGridWidth"
      }
    })
  } else {
    initializeGrid({
      gridName: "installed_systems",
      autoSizeStrategy: {
        defaultMinWidth: 100,
        type: "fitGridWidth"
      },
    })
    initializeGrid({
      gridName: "my_systems",
      autoSizeStrategy: {
        defaultMinWidth: 100,
        type: "fitGridWidth"
      },
    })
    initializeGrid({
      gridName: "collaborator_systems",
      autoSizeStrategy: {
        defaultMinWidth: 100,
        type: "fitGridWidth"
      },
    })
  }
}
